import React from 'react';
import { Border, Button, ButtonContainer, CalendarHeader, CalendarWrapper, ConfirmVisitText } from '../../components/common/CommonModal/style';
import PropTypes from 'prop-types';
import { AdminCloseIcon } from '../../utils/icons';
import { StyledModal } from './style';

function PasswordPopup({show,onCancel}) {

  return(
    <StyledModal show={show} width={'400px'} height={'324px'}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <div>Company password</div>
          </div>
          <div className="close-icon" onClick={onCancel}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <Border/>
        <CalendarWrapper>
          <ConfirmVisitText>Every employee you invite to join the portal will need to enter a company password to access the platform. </ConfirmVisitText>
          <ConfirmVisitText>When invited, they’ll receive an email that includes your company name and the password. They’ll be asked to enter this password during their first login to begin using the platform.</ConfirmVisitText>
          <ButtonContainer>
            <Button
              isWidth={"200px"}
              isHeight="40px"
              isFont={"16px"}
              background="#F37A65"
              color="white"
              onClick={onCancel}
            >
              <div className="btn-text">Got it</div>
            </Button>
          </ButtonContainer>
        </CalendarWrapper>
      </div>
    </StyledModal>
  );}


PasswordPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};
  


export default PasswordPopup;
